export const all_routes = {
  newdashboard: "/:shopId/admin-dashboard",
  dashboard: "/:shopId/admin-dashboard",
  productlist: "/:shopId/product-list",
  addproduct: "/:shopId/add-product",
  addmenu: "/:shopId/add-menu",
  editproduct: "/:shopId/edit-product/:id",
  salesdashboard: "/:shopId/sales-dashboard",
  brandlist: "/:shopId/brand-list",
  units: "/:shopId/units",
  grouplist: "/:shopId/group-list",
  modellist: "/:shopId/model-list",
  variantyattributes: "/:shopId/variant-attributes",
  warranty: "/:shopId/warranty",
  departmentgrid: "/:shopId/department-grid",
  departmentlist: "/:shopId/department-list",
  designation: "/:shopId/designation",
  shift: "/:shopId/shift",
  attendanceemployee: "/:shopId/attendance-employee",
  email: "/:shopId/email",
  expiredstock: "/:shopId/expired-products",
  totransformstock: "/:shopId/transform-stocks",
  lowstock: "/:shopId/low-stocks",
  categorylist: "/:shopId/category-list",
  subcategories: "/:shopId/sub-categories",
  diverspurchaselist: "/:shopId/divers-purchase-list",
  avancesemployee: "/:shopId/avances-employee",
  calendars: "/:shopId/calendar",
  variantattributes: "/:shopId/variant-attributes",
  qrcode: "/:shopId/qrcode",
  supplierorderlist: "/:shopId/supplier-order-list",
  addsupplierorder: "/:shopId/add-supplier-order",
  editsupplierorder: "/:shopId/edit-supplier-order/:id",
  purchaselist: "/:shopId/purchase-list",
  addpurchase: "/:shopId/add-purchase",
  purchasereturn: "/:shopId/purchase-returns",
  appearance: "/:shopId/appearance",
  socialauthendication: "/:shopId/social-authentication",
  languagesettings: "/:shopId/language-settings",
  invoicesettings: "/:shopId/invoice-settings",
  printersettings: "/:shopId/printer-settings",
  possettings: "/:shopId/pos-settings",
  paymentmethod: "/:shopId/payment-method",
  emailsettings: "/:shopId/email-settings",
  smssettings: "/:shopId/sms-gateway",
  otpsettings: "/:shopId/otp-settings",
  gdbrsettings: "/:shopId/gdpr-settings",
  paymentgateway: "/:shopId/payment-gateway-settings",
  banksettingslist: "/:shopId/bank-settings-list",
  banksettingsgrid: "/:shopId/bank-settings-grid",
  taxrates: "/:shopId/tax-rates",
  currencysettings: "/:shopId/currency-settings",
  storagesettings: "/:shopId/storage-settings",
  banipaddress: "/:shopId/ban-ip-address",
  generalsettings: "/:shopId/general-settings",
  securitysettings: "/:shopId/security-settings",
  notification: "/:shopId/notification",
  connectedapps: "/:shopId/connected-apps",
  systemsettings: "/:shopId/system-settings",
  companysettings: "/:shopId/vat-situations",
  companiestypes: "/:shopId/companies-types",

  prefixes: "/:shopId/prefixes",
  preference: "/:shopId/preference",
  saleslist: "/:shopId/sales-list",
  invoicereport: "/:shopId/invoice-report",
  salesreturn: "/:shopId/sales-returns",
  quotelist: "/:shopId/quote-list",
  pos2: "/:shopId/pos-2",
  attendanceadmin: "/:shopId/attendance-admin",
  payslip: "/:shopId/payslip",
  holidays: "/:shopId/holidays",
  customers: "/:shopId/customers",
  suppliers: "/:shopId/suppliers",
  storelist: "/:shopId/store-list",
  //begin
  addstore: "/:shopId/add-store",
  editstore: "/:shopId/edit-store/:storeId",
  zonelist: "/:shopId/zones",
  floorplanlive: "/:shopId/floor-plan",
  mealplans: "/:shopId/meal-plans",
  beneficiarysubs: "/:shopId/beneficiary-subscriptions",
  menulist: "/:shopId/menu-list",
  menuplans: "/:shopId/menu-plans",
  pathology: "/:shopId/pathology",
  allergen:"/:shopId/allergen",
  //end
  managestock: "/:shopId/manage-stocks",
  stockadjustment: "/:shopId/stock-adjustment",
  stocktransfer: "/:shopId/stock-transfer",
  manufacturingorders: "/:shopId/manufacturing-orders",
  editmanufacturingorder: "/:shopId/manufacturing-orders/:id/edit",
  salesreport: "/:shopId/sales-report",
  backlogproduction: "/:shopId/backlog-production",

  // inventoryreport: "/:shopId/inventory-report",
  inventory: "/:shopId/inventory",
  supplierreport: "/:shopId/supplier-report",
  customerreport: "/:shopId/customer-report",
  expensereport: "/:shopId/expense-report",
  incomereport: "/:shopId/income-report",
  taxreport: "/:shopId/tax-report",
  profitloss: "/:shopId/profit-loss-report",
  notes: "/:shopId/notes",
  filemanager: "/:shopId/file-manager",
  profile: "/:shopId/profile",
  signin: "/signin",
  signintwo: "/signin-2",
  signinthree: "/signin-3",
  register: "/register",
  registerTwo: "/register-2",
  registerThree: "/register-3",
  forgotPassword: "/forgot-password",
  forgotPasswordTwo: "/forgot-password-2",
  forgotPasswordThree: "/forgot-password-3",
  resetpassword: "/reset-password",
  resetpasswordTwo: "/reset-password-2",
  resetpasswordThree: "/reset-password-3",
  emailverification: "/email-verification",
  emailverificationTwo: "/email-verification-2",
  emailverificationThree: "/email-verification-3",
  twostepverification: "/two-step-verification",
  twostepverificationTwo: "/two-step-verification-2",
  twostepverificationThree: "/two-step-verification-3",
  users: "/:shopId/users",
  rolespermission: "/:shopId/roles-permissions",
  permissions: "/:shopId/permissions",
  deleteaccount: "/:shopId/delete-account",
  employeegrid: "/:shopId/employees-grid",
  addemployee: "/:shopId/add-employee",
  editemployee: "/:shopId/edit-employee",
  leavesadmin: "/:shopId/leaves-admin",
  leavesemployee: "/:shopId/leaves-employee",
  leavestype: "/:shopId/leave-types",
  warehouses: "/:shopId/warehouse",
  coupons: "/:shopId/coupons",
  payrollList: "/:shopId/employee-salary",

  //New Page
  onlineorder: "/:shopId/online-orders",
  customer: "/:shopId/customer",
  pos: "/:shopId/pos-list",
  posorder: "/:shopId/pos-orders",
  invoice: "/:shopId/invoice-list",
  invoicedetails: "/:shopId/invoice-details/:id",
  pos3: "/:shopId/pos-3",
  pos4: "/:shopId/pos-4",
  pos5: "/:shopId/pos-5",
  GiftCard: "/:shopId/gift-cards",
  discount: "/:shopId/discount",
  discountPlan: "/:shopId/discount-plan",
  accountlist: "/:shopId/account-list",
  moneytransfer: "/:shopId/money-transfer",
  balancesheet: "/:shopId/balance-sheet",
  trailbalance: "/:shopId/trial-balance",
  cashflow: "/:shopId/cash-flow",
  accountstatement: "/:shopId/account-statement",
  customercontract: "/:shopId/customer-contract",
  employeedetails: "/:shopId/employee-details",
  stockhistory: "/:shopId/stock-history",
  soldstock: "/:shopId/sold-stock",
  bestseller: "/:shopId/best-seller",
  invoicereportnew: "/:shopId/invoice-report",
  languagesettingsweb: "/:shopId/language-settings-web",
  success: "/success",
  successTwo: "/success-2",
  successThree: "/success-3",
  employeelist: "/:shopId/employees-list",
  incomelist: "/:shopId/income",
  incomecategory: "/:shopId/income-category",
  product: "/:shopId/products",
  productdetails: "/:shopId/product-details",
  orders: "/:shopId/orders",
  cart: "/:shopId/cart",
  checkout: "/:shopId/checkout",
  wishlist: "/:shopId/wishlist",
  reviews: "/:shopId/reviews",
  superadmindashboard: "/:shopId/dashboard",
  companies: "/:shopId/companies",
  companysetup: "/:shopId/companies/:companyId/setup",
  subscription: "/:shopId/subscription",
  packagelist: "/:shopId/packages",
  domain: "/:shopId/domain",
  purchasetransaction: "/:shopId/purchase-transaction",
  emailreply: "/:shopId/email-replay",
  todolist: "/:shopId/todo-list",
  projects: "/:shopId/projects",
  searchlist: "/:shopId/search-list",
  supplierduereport: "/:shopId/supplier-due-report",
  customerduereport: "/:shopId/customer-due-report",
  productreport: "/:shopId/product-report",
  productexpiredreport: "/:shopId/product-expiry-report",
  productquantityreport: "/:shopId/product-quantity-report",
  salereport: "/:shopId/sales-tax",
  annualreport: "/:shopId/annual-report",
  pagesList: "/:shopId/pages",
  allBlogs: "/:shopId/all-blog",
  blogComments: "/:shopId/blog-comments",
  blogCategories: "/:shopId/blog-categories",
  blogTag: "/:shopId/blog-tag",
  blogDetails: "/:shopId/blog-details",
  invoicetemplate: "/:shopId/invoice-template",
  signatures: "/:shopId/signatures",
  emailtemplate: "/:shopId/email-templates",
  smstemplate: "/:shopId/sms-templates",
  Horizontal: "/:shopId/layout-horizontal",
  Detached: "/:shopId/layout-detached",
  Hovered: "/:shopId/layout-hovered",
  Boxed: "/:shopId/layout-box",
  Modern: "/:shopId/layout-modern",
  TwoColumn: "/:shopId/layout-two-column",
  Dark: "/:shopId/layout-dark",
  RTL: "/:shopId/layout-rtl",
  faq: "/:shopId/faq",
  testimonial: "/:shopId/testimonials",

  contact: "/:shopId/contacts",
  customerorder: "/:shopId/customer-order",
  addcustomerorder: "/:shopId/add-customer-order",
  editcustomerorder: "/:shopId/edit-customer-order/:id",
  detailcustomerorder: "/:shopId/detail-customer-order",
  shoporder: "/:shopId/shop-order",
  addshoporder: "/:shopId/add-shop-order",
  editshoporder: "/:shopId/edit-shop-order/:id",
  detailshoporder: "/:shopId/detail-shop-order",
  quotationdetail: "/:shopId/quotation-detail",
  saledetail: "/:shopId/sale-detail",
  addsale: "/:shopId/add-sale",
  editsale: "/:shopId/edit-sale/:id",
  addinvoice: "/:shopId/add-invoice",
  addquote: "/:shopId/add-quote",
  editquote: "/:shopId/edit-quote/:id",
  editpurchase: "/:shopId/edit-purchase/:id",
  addtransfer: "/:shopId/add-transfer",
  edittransfer: "/:shopId/edit-transfer/:id",
  editinventory: "/:shopId/edit-inventory/:id",
  licenses: "/:shopId/licenses",
  companydetail: "/:shopId/companies/:id",
};
